import { getAdminAxiosInstance } from "../../../../api/Admin";

export const uploadFile = async (body) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`delivery/area-excel-upload`, body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
